import {
  ACTIVITY_MOBILITY_OPTIONS,
  ORAL_HYGIENE_OPTIONS,
  TEETH_TYPE_OPTIONS,
} from "../../../constants/constants";
import {
  buildCarePlanGeniePreview,
  CarePlanGenieFieldDefinition,
  CarePlanGenieQuestion,
} from "./carePlanGenieShared";

export interface ActivitiesOfDailyLivingGenieSectionValues {
  [key: string]: any;
}

const oralHygieneValues = ORAL_HYGIENE_OPTIONS.map((option) => option.value);

export const ADL_GENIE_FIELD_DEFINITIONS: Record<string, CarePlanGenieFieldDefinition> = {
  typeOfMovementWithinFacility: { key: "typeOfMovementWithinFacility", label: "Movement within facility level", type: "choice", applyMode: "replace" },
  movementWithinFacilityDetails: { key: "movementWithinFacilityDetails", label: "Movement within facility details", type: "text", applyMode: "append" },
  movementWithinFacilityAssistanceRequired: { key: "movementWithinFacilityAssistanceRequired", label: "Movement within facility assistance required", type: "text", applyMode: "append" },
  typeOfMovementOutsideFacility: { key: "typeOfMovementOutsideFacility", label: "Movement outside facility level", type: "choice", applyMode: "replace" },
  movementOutsideFacilityDetails: { key: "movementOutsideFacilityDetails", label: "Movement outside facility details", type: "text", applyMode: "append" },
  movementOutsideFacilityAssistanceRequired: { key: "movementOutsideFacilityAssistanceRequired", label: "Movement outside facility assistance required", type: "text", applyMode: "append" },
  anyFallRisks: { key: "anyFallRisks", label: "Any fall risks", type: "boolean", applyMode: "replace" },
  fallRisksDetails: { key: "fallRisksDetails", label: "Fall risks details", type: "text", applyMode: "append" },
  fallRisksAssistanceRequired: { key: "fallRisksAssistanceRequired", label: "Fall risks assistance required", type: "text", applyMode: "append" },
  anyFallPreventionPlan: { key: "anyFallPreventionPlan", label: "Any fall prevention plan", type: "boolean", applyMode: "replace" },
  fallPreventionPlanDetails: { key: "fallPreventionPlanDetails", label: "Fall prevention plan details", type: "text", applyMode: "append" },
  fallPreventionPlanAssistanceRequired: { key: "fallPreventionPlanAssistanceRequired", label: "Fall prevention plan assistance required", type: "text", applyMode: "append" },
  anyEquipmentUsedForMobility: { key: "anyEquipmentUsedForMobility", label: "Any equipment used for mobility", type: "boolean", applyMode: "replace" },
  equipmentUsedForMobilityDetails: { key: "equipmentUsedForMobilityDetails", label: "Equipment used for mobility details", type: "text", applyMode: "append" },
  equipmentUsedForMobilityAssistanceRequired: { key: "equipmentUsedForMobilityAssistanceRequired", label: "Equipment used for mobility assistance required", type: "text", applyMode: "append" },
  anyLimitationsInMobility: { key: "anyLimitationsInMobility", label: "Any limitations in mobility", type: "boolean", applyMode: "replace" },
  limitationsInMobilityDetails: { key: "limitationsInMobilityDetails", label: "Limitations in mobility details", type: "text", applyMode: "append" },
  limitationsInMobilityAssistanceRequired: { key: "limitationsInMobilityAssistanceRequired", label: "Limitations in mobility assistance required", type: "text", applyMode: "append" },
  typeOfBedMobility: { key: "typeOfBedMobility", label: "Bed mobility level", type: "choice", applyMode: "replace" },
  bedMobilityDetails: { key: "bedMobilityDetails", label: "Bed mobility details", type: "text", applyMode: "append" },
  bedMobilityAssistanceRequired: { key: "bedMobilityAssistanceRequired", label: "Bed mobility assistance required", type: "text", applyMode: "append" },
  anyInBedTurningAndRepositioning: { key: "anyInBedTurningAndRepositioning", label: "Any in-bed turning and repositioning", type: "boolean", applyMode: "replace" },
  inBedTurningAndRepositioningDetails: { key: "inBedTurningAndRepositioningDetails", label: "In-bed turning and repositioning details", type: "text", applyMode: "append" },
  inBedTurningAndRepositioningAssistanceRequired: { key: "inBedTurningAndRepositioningAssistanceRequired", label: "In-bed turning and repositioning assistance required", type: "text", applyMode: "append" },
  anyInBedSafetyPlan: { key: "anyInBedSafetyPlan", label: "Any in-bed safety plan", type: "boolean", applyMode: "replace" },
  inBedSafetyPlanDetails: { key: "inBedSafetyPlanDetails", label: "In-bed safety plan details", type: "text", applyMode: "append" },
  inBedSafetyPlanAssistanceRequired: { key: "inBedSafetyPlanAssistanceRequired", label: "In-bed safety plan assistance required", type: "text", applyMode: "append" },
  anyInBedEquipmentOrSupplies: { key: "anyInBedEquipmentOrSupplies", label: "Any in-bed equipment or supplies", type: "boolean", applyMode: "replace" },
  inBedEquipmentOrSuppliesDetails: { key: "inBedEquipmentOrSuppliesDetails", label: "In-bed equipment or supplies details", type: "text", applyMode: "append" },
  inBedEquipmentOrSuppliesAssistanceRequired: { key: "inBedEquipmentOrSuppliesAssistanceRequired", label: "In-bed equipment or supplies assistance required", type: "text", applyMode: "append" },
  typeOfEatingBehavior: { key: "typeOfEatingBehavior", label: "Eating level", type: "choice", applyMode: "replace" },
  eatingBehaviorDetails: { key: "eatingBehaviorDetails", label: "Eating behavior details", type: "text", applyMode: "append" },
  eatingBehaviorAssistanceRequired: { key: "eatingBehaviorAssistanceRequired", label: "Eating behavior assistance required", type: "text", applyMode: "append" },
  anySpecialDietaryNeeds: { key: "anySpecialDietaryNeeds", label: "Any special dietary needs", type: "boolean", applyMode: "replace" },
  specialDietaryNeedsDetails: { key: "specialDietaryNeedsDetails", label: "Special dietary needs details", type: "text", applyMode: "append" },
  specialDietaryNeedsAssistanceRequired: { key: "specialDietaryNeedsAssistanceRequired", label: "Special dietary needs assistance required", type: "text", applyMode: "append" },
  anyFoodAllergies: { key: "anyFoodAllergies", label: "Any food allergies", type: "boolean", applyMode: "replace" },
  foodAllergiesDetails: { key: "foodAllergiesDetails", label: "Food allergies details", type: "text", applyMode: "append" },
  foodAllergiesAssistanceRequired: { key: "foodAllergiesAssistanceRequired", label: "Food allergies assistance required", type: "text", applyMode: "append" },
  anyEatingEquipmentUsed: { key: "anyEatingEquipmentUsed", label: "Any eating equipment used", type: "boolean", applyMode: "replace" },
  eatingEquipmentUsedDetails: { key: "eatingEquipmentUsedDetails", label: "Eating equipment used details", type: "text", applyMode: "append" },
  eatingEquipmentUsedAssistanceRequired: { key: "eatingEquipmentUsedAssistanceRequired", label: "Eating equipment used assistance required", type: "text", applyMode: "append" },
  typeOfToiletHandling: { key: "typeOfToiletHandling", label: "Toileting level", type: "choice", applyMode: "replace" },
  toiletHandlingDetails: { key: "toiletHandlingDetails", label: "Toileting details", type: "text", applyMode: "append" },
  toiletHandlingAssistanceRequired: { key: "toiletHandlingAssistanceRequired", label: "Toileting assistance required", type: "text", applyMode: "append" },
  anyBladderContinenceIssues: { key: "anyBladderContinenceIssues", label: "Any bladder continence issues", type: "boolean", applyMode: "replace" },
  bladderContinenceIssuesDetails: { key: "bladderContinenceIssuesDetails", label: "Bladder continence issues details", type: "text", applyMode: "append" },
  bladderContinenceIssuesAssistanceRequired: { key: "bladderContinenceIssuesAssistanceRequired", label: "Bladder continence issues assistance required", type: "text", applyMode: "append" },
  anyBowelContinenceIssues: { key: "anyBowelContinenceIssues", label: "Any bowel continence issues", type: "boolean", applyMode: "replace" },
  bowelContinenceIssuesDetails: { key: "bowelContinenceIssuesDetails", label: "Bowel continence issues details", type: "text", applyMode: "append" },
  bowelContinenceIssuesAssistanceRequired: { key: "bowelContinenceIssuesAssistanceRequired", label: "Bowel continence issues assistance required", type: "text", applyMode: "append" },
  anyToiletingEquipmentUsed: { key: "anyToiletingEquipmentUsed", label: "Any toileting equipment used", type: "boolean", applyMode: "replace" },
  toiletingEquipmentUsedDetails: { key: "toiletingEquipmentUsedDetails", label: "Toileting equipment used details", type: "text", applyMode: "append" },
  toiletingEquipmentUsedAssistanceRequired: { key: "toiletingEquipmentUsedAssistanceRequired", label: "Toileting equipment used assistance required", type: "text", applyMode: "append" },
  typeOfDressing: { key: "typeOfDressing", label: "Dressing level", type: "choice", applyMode: "replace" },
  dressingDetails: { key: "dressingDetails", label: "Dressing details", type: "text", applyMode: "append" },
  dressingAssistanceRequired: { key: "dressingAssistanceRequired", label: "Dressing assistance required", type: "text", applyMode: "append" },
  anyDressingEquipmentUsed: { key: "anyDressingEquipmentUsed", label: "Any dressing equipment used", type: "boolean", applyMode: "replace" },
  dressingEquipmentUsedDetails: { key: "dressingEquipmentUsedDetails", label: "Dressing equipment used details", type: "text", applyMode: "append" },
  dressingEquipmentUsedAssistanceRequired: { key: "dressingEquipmentUsedAssistanceRequired", label: "Dressing equipment used assistance required", type: "text", applyMode: "append" },
  typeOfPersonalHygiene: { key: "typeOfPersonalHygiene", label: "Personal hygiene level", type: "choice", applyMode: "replace" },
  personalHygieneDetails: { key: "personalHygieneDetails", label: "Personal hygiene details", type: "text", applyMode: "append" },
  personalHygieneAssistanceRequired: { key: "personalHygieneAssistanceRequired", label: "Personal hygiene assistance required", type: "text", applyMode: "append" },
  teethType: { key: "teethType", label: "Teeth type", type: "choice", applyMode: "replace" },
  teethTypeDetails: { key: "teethTypeDetails", label: "Teeth type details", type: "text", applyMode: "append" },
  teethTypeAssistanceRequired: { key: "teethTypeAssistanceRequired", label: "Teeth type assistance required", type: "text", applyMode: "append" },
  anyOralHygieneCare: { key: "anyOralHygieneCare", label: "Any oral hygiene care", type: "stringArray", applyMode: "mergeArray" },
  oralHygieneCareDetails: { key: "oralHygieneCareDetails", label: "Oral hygiene care details", type: "text", applyMode: "append" },
  oralHygieneCareAssistanceRequired: { key: "oralHygieneCareAssistanceRequired", label: "Oral hygiene care assistance required", type: "text", applyMode: "append" },
  typeOfBathing: { key: "typeOfBathing", label: "Bathing level", type: "choice", applyMode: "replace" },
  bathingDetails: { key: "bathingDetails", label: "Bathing details", type: "text", applyMode: "append" },
  bathingAssistanceRequired: { key: "bathingAssistanceRequired", label: "Bathing assistance required", type: "text", applyMode: "append" },
  anyBathingEquipmentUsed: { key: "anyBathingEquipmentUsed", label: "Any bathing equipment used", type: "boolean", applyMode: "replace" },
  bathingEquipmentUsedDetails: { key: "bathingEquipmentUsedDetails", label: "Bathing equipment used details", type: "text", applyMode: "append" },
  bathingEquipmentUsedAssistanceRequired: { key: "bathingEquipmentUsedAssistanceRequired", label: "Bathing equipment used assistance required", type: "text", applyMode: "append" },
  typeOfFootCare: { key: "typeOfFootCare", label: "Foot care level", type: "choice", applyMode: "replace" },
  footCareDetails: { key: "footCareDetails", label: "Foot care details", type: "text", applyMode: "append" },
  footCareAssistanceRequired: { key: "footCareAssistanceRequired", label: "Foot care assistance required", type: "text", applyMode: "append" },
  anyDiabeticFootCare: { key: "anyDiabeticFootCare", label: "Any diabetic foot care", type: "boolean", applyMode: "replace" },
  diabeticFootCareDetails: { key: "diabeticFootCareDetails", label: "Diabetic foot care details", type: "text", applyMode: "append" },
  diabeticFootCareAssistanceRequired: { key: "diabeticFootCareAssistanceRequired", label: "Diabetic foot care assistance required", type: "text", applyMode: "append" },
  anyNailCare: { key: "anyNailCare", label: "Any nail care", type: "boolean", applyMode: "replace" },
  nailCareDetails: { key: "nailCareDetails", label: "Nail care details", type: "text", applyMode: "append" },
  nailCareAssistanceRequired: { key: "nailCareAssistanceRequired", label: "Nail care assistance required", type: "text", applyMode: "append" },
  typeOfSkinCare: { key: "typeOfSkinCare", label: "Skin care level", type: "choice", applyMode: "replace" },
  skinCareDetails: { key: "skinCareDetails", label: "Skin care details", type: "text", applyMode: "append" },
  skinCareAssistanceRequired: { key: "skinCareAssistanceRequired", label: "Skin care assistance required", type: "text", applyMode: "append" },
  anySkinProblems: { key: "anySkinProblems", label: "Any skin problems", type: "boolean", applyMode: "replace" },
  skinProblemsDetails: { key: "skinProblemsDetails", label: "Skin problems details", type: "text", applyMode: "append" },
  skinProblemsAssistanceRequired: { key: "skinProblemsAssistanceRequired", label: "Skin problems assistance required", type: "text", applyMode: "append" },
  anyPressureInjuries: { key: "anyPressureInjuries", label: "Any pressure injuries", type: "boolean", applyMode: "replace" },
  pressureInjuriesDetails: { key: "pressureInjuriesDetails", label: "Pressure injuries details", type: "text", applyMode: "append" },
  pressureInjuriesAssistanceRequired: { key: "pressureInjuriesAssistanceRequired", label: "Pressure injuries assistance required", type: "text", applyMode: "append" },
};

const levelQuestion = (
  id: string,
  title: string,
  prompt: string,
  levelField: string,
  detailField: string,
  assistanceField: string,
  detailContext: string,
  interventionContext: string,
): CarePlanGenieQuestion => ({
  id,
  title,
  prompt,
  helperText: "Choose the level that fits best, then add caregiver interventions that should happen consistently.",
  editableFieldKeys: [detailField, assistanceField],
  options: [
    {
      id: `${id}_independent`,
      label: "Independent",
      description: "Resident usually completes this area without hands-on help.",
      groupLabel: "Care details",
      updates: {
        [levelField]: ACTIVITY_MOBILITY_OPTIONS[0],
        [detailField]: `Resident is generally independent with ${detailContext} and usually completes the task safely with minimal prompting.`,
      },
    },
    {
      id: `${id}_supervision`,
      label: "Supervision or cueing",
      description: "Needs reminders, setup, or observation more than physical help.",
      groupLabel: "Care details",
      updates: {
        [levelField]: ACTIVITY_MOBILITY_OPTIONS[1],
        [detailField]: `Resident benefits from supervision, cueing, or setup support for ${detailContext}, especially when routine, safety, or sequencing is affected.`,
      },
    },
    {
      id: `${id}_limited`,
      label: "Limited assistance",
      description: "Needs some hands-on help or guidance for part of the task.",
      groupLabel: "Care details",
      updates: {
        [levelField]: ACTIVITY_MOBILITY_OPTIONS[2],
        [detailField]: `Resident needs limited assistance with ${detailContext} and may complete parts of the task with cueing, setup, or light physical help.`,
      },
    },
    {
      id: `${id}_extensive`,
      label: "Extensive or total help",
      description: "Needs significant hands-on support or full caregiver completion.",
      groupLabel: "Care details",
      updates: {
        [levelField]: ACTIVITY_MOBILITY_OPTIONS[3],
        [detailField]: `Resident needs extensive assistance with ${detailContext} and may rely on caregiver for major portions of the task to maintain safety, comfort, and follow-through.`,
      },
    },
    {
      id: `${id}_safety`,
      label: "Use consistent safety-focused assistance",
      description: "Caregivers should follow the same support approach every time.",
      groupLabel: "Caregiver interventions",
      updates: {
        [assistanceField]: `Caregivers should use a consistent approach for ${interventionContext}, give step-by-step cueing, and adjust hands-on support based on the resident's daily condition and safety needs.`,
      },
    },
    {
      id: `${id}_pace`,
      label: "Allow time, cueing, and reassurance",
      description: "Helpful when the resident does better with calm pacing.",
      groupLabel: "Caregiver interventions",
      updates: {
        [assistanceField]: `Caregivers should allow enough time for ${interventionContext}, avoid rushing, and use calm cueing and reassurance when the resident becomes hesitant, fatigued, or confused.`,
      },
    },
    {
      id: `${id}_observe`,
      label: "Observe tolerance and daily condition changes",
      description: "Use when the resident's function can vary by pain, fatigue, weakness, or confusion.",
      groupLabel: "Caregiver interventions",
      updates: {
        [assistanceField]: `Caregivers should observe tolerance, pain, fatigue, weakness, confusion, and other day-to-day changes related to ${interventionContext} and adjust support promptly when needs increase.`,
      },
    },
    {
      id: `${id}_setup`,
      label: "Prepare the environment and supplies first",
      description: "Helpful when setup, positioning, or reduced distractions improve success.",
      groupLabel: "Caregiver interventions",
      updates: {
        [assistanceField]: `Caregivers should prepare the environment, position needed supplies, reduce hazards, and set up the task clearly before assisting with ${interventionContext}.`,
      },
    },
    {
      id: `${id}_participation`,
      label: "Encourage safe participation step by step",
      description: "Use when the resident can still do parts of the task with support.",
      groupLabel: "Caregiver interventions",
      updates: {
        [assistanceField]: `Caregivers should encourage the resident to participate in each step of ${interventionContext} as able, provide cueing in small steps, and use only the level of hands-on help needed for safety.`,
      },
    },
    {
      id: `${id}_report`,
      label: "Report decline, refusal, or new safety concerns",
      description: "Important when the resident's baseline may be changing.",
      groupLabel: "Caregiver interventions",
      updates: {
        [assistanceField]: `Caregivers should report decline from baseline, increased refusal, pain, new safety concerns, or increasing assistance needs related to ${interventionContext} so the care plan can be updated promptly.`,
      },
    },
  ],
});

export const ADL_GENIE_QUESTIONS: CarePlanGenieQuestion[] = [
  levelQuestion(
    "mobility_within",
    "Mobility Within Facility",
    "What best describes the resident's mobility within the facility?",
    "typeOfMovementWithinFacility",
    "movementWithinFacilityDetails",
    "movementWithinFacilityAssistanceRequired",
    "moving within the room and immediate living area",
    "mobility within the room and living environment",
  ),
  levelQuestion(
    "mobility_outside",
    "Mobility Outside Facility",
    "What best describes the resident's mobility outside the immediate living area?",
    "typeOfMovementOutsideFacility",
    "movementOutsideFacilityDetails",
    "movementOutsideFacilityAssistanceRequired",
    "moving outside the immediate living environment, including outdoors",
    "outside mobility and community movement",
  ),
  {
    id: "fall_risk",
    title: "Fall Risk and Prevention",
    prompt: "What should be documented about fall risks and the prevention plan?",
    helperText: "Choose fall-risk details and the prevention steps caregivers should follow.",
    editableFieldKeys: [
      "fallRisksDetails",
      "fallRisksAssistanceRequired",
      "fallPreventionPlanDetails",
      "fallPreventionPlanAssistanceRequired",
    ],
    options: [
      {
        id: "fall_risk_present",
        label: "Fall risk is present",
        description: "Resident has balance, weakness, impulsivity, or transfer-related risk factors.",
        groupLabel: "Care details",
        updates: {
          anyFallRisks: true,
          fallRisksDetails: "Resident has fall risk related to balance changes, weakness, poor safety awareness, variable mobility, or transfers that require added attention.",
        },
      },
      {
        id: "fall_risk_history",
        label: "Past falls or near-falls affect the plan",
        description: "History should inform the current support approach.",
        groupLabel: "Care details",
        updates: {
          anyFallRisks: true,
          fallRisksDetails: "Past falls, near-falls, or changes in gait should be considered when planning supervision and support for safe mobility.",
        },
      },
      {
        id: "fall_plan",
        label: "Fall prevention plan should be active",
        description: "Resident needs documented prevention steps.",
        groupLabel: "Care details",
        updates: {
          anyFallPreventionPlan: true,
          fallPreventionPlanDetails: "Resident benefits from a fall prevention plan that addresses supervision, cueing, equipment use, and environment setup.",
        },
      },
      {
        id: "fall_intervention_checks",
        label: "Use frequent checks and supervision",
        description: "Caregivers should adjust observation to the resident's condition.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyFallRisks: true,
          fallRisksAssistanceRequired: "Caregivers should use appropriate supervision, frequent safety checks, and timely assistance during transfers or mobility based on current fall risk.",
        },
      },
      {
        id: "fall_intervention_environment",
        label: "Keep the environment safe and uncluttered",
        description: "Reduce preventable fall hazards.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyFallPreventionPlan: true,
          fallPreventionPlanAssistanceRequired: "Caregivers should keep pathways clear, position needed items within reach, use footwear and equipment appropriately, and reinforce the fall prevention plan consistently.",
        },
      },
    ],
  },
  {
    id: "mobility_equipment",
    title: "Mobility Equipment and Limitations",
    prompt: "What mobility equipment or limitations should be documented?",
    helperText: "Choose details about devices and movement limitations, then add the caregiver support steps.",
    editableFieldKeys: [
      "equipmentUsedForMobilityDetails",
      "equipmentUsedForMobilityAssistanceRequired",
      "limitationsInMobilityDetails",
      "limitationsInMobilityAssistanceRequired",
    ],
    options: [
      {
        id: "mobility_equipment_device",
        label: "Uses mobility equipment",
        description: "Walker, wheelchair, cane, gait belt, or other devices are part of care.",
        groupLabel: "Care details",
        updates: {
          anyEquipmentUsedForMobility: true,
          equipmentUsedForMobilityDetails: "Resident uses mobility equipment such as a walker, wheelchair, cane, gait belt, or other support device during movement and transfers.",
        },
      },
      {
        id: "mobility_equipment_limitations",
        label: "Has mobility limitations",
        description: "Pain, weakness, endurance, or coordination affects movement.",
        groupLabel: "Care details",
        updates: {
          anyLimitationsInMobility: true,
          limitationsInMobilityDetails: "Resident has mobility limitations related to weakness, pain, endurance, stiffness, coordination, or safety awareness that affect movement and participation.",
        },
      },
      {
        id: "mobility_equipment_intervention",
        label: "Apply equipment correctly and monitor tolerance",
        description: "Caregivers should make sure devices are used safely every time.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyEquipmentUsedForMobility: true,
          equipmentUsedForMobilityAssistanceRequired: "Caregivers should make sure mobility equipment is available, positioned correctly, and used safely while monitoring tolerance and reporting changes in function.",
        },
      },
      {
        id: "mobility_limitations_intervention",
        label: "Adjust activity to daily condition and fatigue",
        description: "Support may vary day to day.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyLimitationsInMobility: true,
          limitationsInMobilityAssistanceRequired: "Caregivers should pace mobility tasks, adjust support to fatigue or pain, and provide hands-on help or rest breaks as needed for safety.",
        },
      },
    ],
  },
  levelQuestion(
    "bed_mobility",
    "Bed Mobility",
    "What best describes the resident's bed mobility and transfer-related needs?",
    "typeOfBedMobility",
    "bedMobilityDetails",
    "bedMobilityAssistanceRequired",
    "moving, positioning, and participating in bed mobility",
    "bed mobility and in-bed repositioning",
  ),
  {
    id: "in_bed_support",
    title: "In-Bed Support",
    prompt: "What in-bed care, repositioning, safety, or equipment needs should be documented?",
    helperText: "Choose the in-bed support details that apply and the caregiver steps that should happen routinely.",
    editableFieldKeys: [
      "inBedTurningAndRepositioningDetails",
      "inBedTurningAndRepositioningAssistanceRequired",
      "inBedSafetyPlanDetails",
      "inBedSafetyPlanAssistanceRequired",
      "inBedEquipmentOrSuppliesDetails",
      "inBedEquipmentOrSuppliesAssistanceRequired",
    ],
    options: [
      {
        id: "in_bed_turning",
        label: "Needs turning or repositioning",
        description: "Position changes are part of routine care and skin protection.",
        groupLabel: "Care details",
        updates: {
          anyInBedTurningAndRepositioning: true,
          inBedTurningAndRepositioningDetails: "Resident needs scheduled or situational turning and repositioning to support comfort, skin protection, alignment, or respiratory status.",
        },
      },
      {
        id: "in_bed_safety",
        label: "Has an in-bed safety plan",
        description: "Bed safety steps should be followed consistently.",
        groupLabel: "Care details",
        updates: {
          anyInBedSafetyPlan: true,
          inBedSafetyPlanDetails: "Resident needs an in-bed safety plan related to positioning, call access, monitoring, bed setup, or nighttime safety concerns.",
        },
      },
      {
        id: "in_bed_equipment",
        label: "Uses in-bed equipment or supplies",
        description: "Positioning devices or bed-related supplies are part of care.",
        groupLabel: "Care details",
        updates: {
          anyInBedEquipmentOrSupplies: true,
          inBedEquipmentOrSuppliesDetails: "Resident uses in-bed equipment or supplies such as wedges, pillows, bed supports, protective items, or other positioning aids.",
        },
      },
      {
        id: "in_bed_intervention_turning",
        label: "Reposition on schedule and check comfort",
        description: "Caregivers should follow a routine and assess tolerance.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyInBedTurningAndRepositioning: true,
          inBedTurningAndRepositioningAssistanceRequired: "Caregivers should reposition the resident as directed, check comfort and alignment, and watch for skin risk or intolerance during in-bed care.",
        },
      },
      {
        id: "in_bed_intervention_safety",
        label: "Keep safety setup consistent overnight",
        description: "Use the same bed-safety approach across caregivers.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyInBedSafetyPlan: true,
          inBedSafetyPlanAssistanceRequired: "Caregivers should keep the in-bed safety setup consistent, maintain access to call support and needed items, and follow the resident's nighttime safety plan.",
        },
      },
      {
        id: "in_bed_intervention_equipment",
        label: "Apply equipment correctly and monitor skin",
        description: "Positioning aids should be used safely and checked routinely.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyInBedEquipmentOrSupplies: true,
          inBedEquipmentOrSuppliesAssistanceRequired: "Caregivers should place in-bed equipment or supplies correctly, monitor skin and comfort, and report if positioning supports are no longer effective or tolerated.",
        },
      },
    ],
  },
  levelQuestion(
    "eating_level",
    "Eating",
    "What best describes the resident's eating level?",
    "typeOfEatingBehavior",
    "eatingBehaviorDetails",
    "eatingBehaviorAssistanceRequired",
    "eating, meal participation, and oral intake",
    "eating support and meal assistance",
  ),
  {
    id: "eating_supports",
    title: "Eating Supports",
    prompt: "What dietary needs, allergies, or eating equipment should be documented?",
    helperText: "Choose assessment details and the caregiver steps that support safe, consistent eating.",
    editableFieldKeys: [
      "specialDietaryNeedsDetails",
      "specialDietaryNeedsAssistanceRequired",
      "foodAllergiesDetails",
      "foodAllergiesAssistanceRequired",
      "eatingEquipmentUsedDetails",
      "eatingEquipmentUsedAssistanceRequired",
    ],
    options: [
      {
        id: "eating_diet",
        label: "Has special dietary needs",
        description: "Texture, consistency, meal plan, or medical diet needs should be followed.",
        groupLabel: "Care details",
        updates: {
          anySpecialDietaryNeeds: true,
          specialDietaryNeedsDetails: "Resident has special dietary needs related to prescribed diet, texture, consistency, nutritional support, or medical restrictions.",
        },
      },
      {
        id: "eating_allergies",
        label: "Has food allergies or significant food precautions",
        description: "Important safety details should be visible to caregiver.",
        groupLabel: "Care details",
        updates: {
          anyFoodAllergies: true,
          foodAllergiesDetails: "Resident has food allergies, sensitivities, or specific food-related precautions that should be clearly communicated during meal support.",
        },
      },
      {
        id: "eating_equipment",
        label: "Uses adaptive eating equipment",
        description: "Utensils, cups, guards, or other supports help with meals.",
        groupLabel: "Care details",
        updates: {
          anyEatingEquipmentUsed: true,
          eatingEquipmentUsedDetails: "Resident uses adaptive eating equipment such as special utensils, cups, plate guards, or other meal-time supports.",
        },
      },
      {
        id: "eating_intervention_diet",
        label: "Follow the diet plan and watch intake",
        description: "Caregivers should stay consistent with the resident's eating plan.",
        groupLabel: "Caregiver interventions",
        updates: {
          anySpecialDietaryNeeds: true,
          specialDietaryNeedsAssistanceRequired: "Caregivers should follow the resident's diet plan, observe tolerance and intake, and report poor intake, refusal, or swallowing-related concerns promptly.",
        },
      },
      {
        id: "eating_intervention_allergy",
        label: "Protect against allergy exposure",
        description: "Meal setup and communication should reduce risk.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyFoodAllergies: true,
          foodAllergiesAssistanceRequired: "Caregivers should avoid allergy triggers, verify safe meal setup, and communicate food precautions clearly during preparation and service.",
        },
      },
      {
        id: "eating_intervention_equipment",
        label: "Set up adaptive equipment each meal",
        description: "Equipment should be ready and used the same way each time.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyEatingEquipmentUsed: true,
          eatingEquipmentUsedAssistanceRequired: "Caregivers should make adaptive eating equipment available at meals, position it correctly, and help the resident use it safely and consistently.",
        },
      },
    ],
  },
  levelQuestion(
    "toileting_level",
    "Toileting",
    "What best describes the resident's toileting level?",
    "typeOfToiletHandling",
    "toiletHandlingDetails",
    "toiletHandlingAssistanceRequired",
    "toileting, bathroom use, and continence-related care",
    "toileting support and bathroom assistance",
  ),
  {
    id: "continence",
    title: "Continence and Toileting Supports",
    prompt: "What continence issues or toileting equipment should be documented?",
    helperText: "Choose continence details and the caregiver support steps that should happen routinely.",
    editableFieldKeys: [
      "bladderContinenceIssuesDetails",
      "bladderContinenceIssuesAssistanceRequired",
      "bowelContinenceIssuesDetails",
      "bowelContinenceIssuesAssistanceRequired",
      "toiletingEquipmentUsedDetails",
      "toiletingEquipmentUsedAssistanceRequired",
    ],
    options: [
      {
        id: "continence_bladder",
        label: "Has bladder continence needs",
        description: "Urgency, leakage, scheduled toileting, or monitoring is part of care.",
        groupLabel: "Care details",
        updates: {
          anyBladderContinenceIssues: true,
          bladderContinenceIssuesDetails: "Resident has bladder continence needs that may include urgency, leakage, scheduled toileting, product use, or monitoring for changes.",
        },
      },
      {
        id: "continence_bowel",
        label: "Has bowel continence needs",
        description: "Bowel pattern, incontinence, or bowel support should be documented.",
        groupLabel: "Care details",
        updates: {
          anyBowelContinenceIssues: true,
          bowelContinenceIssuesDetails: "Resident has bowel continence needs or bowel-pattern concerns that affect routine care, comfort, hygiene, or monitoring.",
        },
      },
      {
        id: "continence_equipment",
        label: "Uses toileting equipment",
        description: "Raised seat, commode, grab bars, or other supports are part of the plan.",
        groupLabel: "Care details",
        updates: {
          anyToiletingEquipmentUsed: true,
          toiletingEquipmentUsedDetails: "Resident uses toileting equipment such as a commode, raised seat, grab bars, or other supports to improve safety and access.",
        },
      },
      {
        id: "continence_intervention_schedule",
        label: "Use routine toileting schedule and monitoring",
        description: "Caregivers should follow timing and watch patterns.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyBladderContinenceIssues: true,
          bladderContinenceIssuesAssistanceRequired: "Caregivers should follow toileting routines, monitor output patterns, provide timely assistance, and report notable continence changes or symptoms.",
        },
      },
      {
        id: "continence_intervention_skin",
        label: "Support hygiene and protect skin",
        description: "Important when continence issues affect comfort or skin integrity.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyBowelContinenceIssues: true,
          bowelContinenceIssuesAssistanceRequired: "Caregivers should provide prompt hygiene support, protect skin, and report constipation, diarrhea, incontinence changes, or bowel-pattern concerns.",
        },
      },
      {
        id: "continence_intervention_equipment",
        label: "Set up toileting equipment safely",
        description: "Equipment should be stable and ready when needed.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyToiletingEquipmentUsed: true,
          toiletingEquipmentUsedAssistanceRequired: "Caregivers should place toileting equipment safely, keep it clean and accessible, and assist the resident with setup and transfers as needed.",
        },
      },
    ],
  },
  levelQuestion(
    "dressing",
    "Dressing",
    "What best describes the resident's dressing level?",
    "typeOfDressing",
    "dressingDetails",
    "dressingAssistanceRequired",
    "dressing and clothing management",
    "dressing support and clothing setup",
  ),
  {
    id: "dressing_supports",
    title: "Dressing Supports",
    prompt: "What dressing equipment or limitations should be documented?",
    helperText: "Choose dressing details and the caregiver steps that should happen consistently.",
    editableFieldKeys: [
      "dressingEquipmentUsedDetails",
      "dressingEquipmentUsedAssistanceRequired",
      "dressingDetails",
      "dressingAssistanceRequired",
    ],
    options: [
      {
        id: "dressing_equipment",
        label: "Uses dressing equipment or adaptive setup",
        description: "Special devices, easy-access clothing, or setup aids help with dressing.",
        groupLabel: "Care details",
        updates: {
          anyDressingEquipmentUsed: true,
          dressingEquipmentUsedDetails: "Resident may use adaptive dressing equipment, modified clothing, or setup supports to help with dressing tasks.",
        },
      },
      {
        id: "dressing_limitation",
        label: "Has pain, range-of-motion, or sequencing limits",
        description: "Physical or cognitive factors make dressing harder.",
        groupLabel: "Care details",
        updates: {
          dressingDetails: "Dressing may be affected by weakness, pain, limited range of motion, cognitive changes, or difficulty sequencing clothing steps.",
        },
      },
      {
        id: "dressing_intervention_setup",
        label: "Lay out clothes and cue step by step",
        description: "Helpful when the resident does better with preparation and simple direction.",
        groupLabel: "Caregiver interventions",
        updates: {
          dressingAssistanceRequired: "Caregivers should lay out clothing, cue each step as needed, and provide hands-on help with fasteners, lower-body dressing, or safety concerns.",
        },
      },
      {
        id: "dressing_intervention_equipment",
        label: "Use adaptive equipment and monitor comfort",
        description: "Caregivers should make sure aids are ready and used correctly.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyDressingEquipmentUsed: true,
          dressingEquipmentUsedAssistanceRequired: "Caregivers should set up adaptive dressing supports, encourage resident participation, and watch for discomfort, fatigue, or increased need for help.",
        },
      },
    ],
  },
  levelQuestion(
    "hygiene",
    "Personal Hygiene",
    "What best describes the resident's personal hygiene level?",
    "typeOfPersonalHygiene",
    "personalHygieneDetails",
    "personalHygieneAssistanceRequired",
    "grooming and personal hygiene routines",
    "personal hygiene support and grooming tasks",
  ),
  {
    id: "oral_hygiene",
    title: "Oral Hygiene and Teeth",
    prompt: "What should be documented about teeth type and oral hygiene supports?",
    helperText: "Choose details about teeth, oral care tasks, and the caregiver steps that help keep oral hygiene consistent.",
    editableFieldKeys: [
      "teethTypeDetails",
      "teethTypeAssistanceRequired",
      "oralHygieneCareDetails",
      "oralHygieneCareAssistanceRequired",
    ],
    options: [
      ...TEETH_TYPE_OPTIONS.map((option) => ({
      id: `teeth_${option.toLowerCase().replace(/\s+/g, "_")}`,
      label: option,
      description: `Resident uses ${option.toLowerCase()} and oral care should reflect that.`,
      groupLabel: "Care details",
      updates: {
        teethType: option,
        teethTypeDetails: `Resident uses ${option.toLowerCase()} and oral care should follow the resident's comfort, fit, and routine oral hygiene needs.`,
      },
    })),
      {
        id: "oral_hygiene_tasks",
        label: "Oral hygiene tasks are part of routine care",
        description: "Brushing, flossing, or soaking should be documented clearly.",
        groupLabel: "Care details",
        updates: {
          anyOralHygieneCare: oralHygieneValues,
          oralHygieneCareDetails: "Routine oral hygiene may include brushing, flossing, soaking, denture care, and observation for oral discomfort or hygiene concerns.",
        },
      },
      {
        id: "oral_hygiene_intervention_teeth",
        label: "Assist with oral care setup and follow-through",
        description: "Caregivers should use the resident's usual oral care routine.",
        groupLabel: "Caregiver interventions",
        updates: {
          teethTypeAssistanceRequired: "Caregivers should help with oral care setup, cleaning routine, denture or partial handling, and observation for fit issues, pain, or oral changes.",
        },
      },
      {
        id: "oral_hygiene_intervention_tasks",
        label: "Cue, assist, and observe the mouth regularly",
        description: "Important when the resident needs reminders or hands-on care.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyOralHygieneCare: oralHygieneValues,
          oralHygieneCareAssistanceRequired: "Caregivers should cue or assist with oral hygiene tasks, maintain supplies, and report oral pain, sores, poor intake related to mouth issues, or hygiene changes.",
        },
      },
    ],
  },
  levelQuestion(
    "bathing",
    "Bathing",
    "What best describes the resident's bathing level?",
    "typeOfBathing",
    "bathingDetails",
    "bathingAssistanceRequired",
    "bathing and showering routines",
    "bathing support and shower safety",
  ),
  {
    id: "bathing_supports",
    title: "Bathing Supports",
    prompt: "What bathing equipment or limitations should be documented?",
    helperText: "Choose bathing details and the caregiver steps that should happen consistently.",
    editableFieldKeys: [
      "bathingEquipmentUsedDetails",
      "bathingEquipmentUsedAssistanceRequired",
      "bathingDetails",
      "bathingAssistanceRequired",
    ],
    options: [
      {
        id: "bathing_equipment",
        label: "Uses bathing equipment",
        description: "Shower chair, grab bars, hand-held shower, or other supports are part of care.",
        groupLabel: "Care details",
        updates: {
          anyBathingEquipmentUsed: true,
          bathingEquipmentUsedDetails: "Resident uses bathing equipment such as a shower chair, grab bars, hand-held shower, nonslip supports, or other adaptive setup during bathing.",
        },
      },
      {
        id: "bathing_limitations",
        label: "Has bathing-related limitations",
        description: "Pain, fatigue, cognition, or fear affects the task.",
        groupLabel: "Care details",
        updates: {
          bathingDetails: "Bathing may be affected by limited endurance, pain, fear of falling, cognitive change, temperature sensitivity, or difficulty reaching parts of the body.",
        },
      },
      {
        id: "bathing_intervention_safety",
        label: "Use a consistent bathing safety routine",
        description: "Caregivers should prepare the space and assist calmly.",
        groupLabel: "Caregiver interventions",
        updates: {
          bathingAssistanceRequired: "Caregivers should prepare the bathing area, support safe transfers, monitor comfort and temperature, and give step-by-step help based on the resident's bathing tolerance.",
        },
      },
      {
        id: "bathing_intervention_equipment",
        label: "Set up bathing equipment each time",
        description: "Equipment should be ready and positioned correctly before bathing starts.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyBathingEquipmentUsed: true,
          bathingEquipmentUsedAssistanceRequired: "Caregivers should place bathing equipment correctly, keep supplies within reach, and adjust support if the resident's balance or tolerance changes.",
        },
      },
    ],
  },
  levelQuestion(
    "foot_care",
    "Foot Care",
    "What best describes the resident's foot care level?",
    "typeOfFootCare",
    "footCareDetails",
    "footCareAssistanceRequired",
    "foot care and routine foot observation",
    "foot care support and monitoring",
  ),
  {
    id: "foot_care_supports",
    title: "Foot Care Supports",
    prompt: "What diabetic foot care or nail care needs should be documented?",
    helperText: "Choose foot-care details and the caregiver steps that should happen routinely.",
    editableFieldKeys: [
      "diabeticFootCareDetails",
      "diabeticFootCareAssistanceRequired",
      "nailCareDetails",
      "nailCareAssistanceRequired",
    ],
    options: [
      {
        id: "foot_diabetic",
        label: "Needs diabetic foot care monitoring",
        description: "Skin checks, circulation concerns, or protective care are important.",
        groupLabel: "Care details",
        updates: {
          anyDiabeticFootCare: true,
          diabeticFootCareDetails: "Resident needs diabetic foot care monitoring related to skin integrity, sensation, circulation, protective footwear, or daily foot observation.",
        },
      },
      {
        id: "foot_nail",
        label: "Needs nail care support",
        description: "Routine nail observation or support is part of care.",
        groupLabel: "Care details",
        updates: {
          anyNailCare: true,
          nailCareDetails: "Resident needs nail care support, observation, or coordination related to routine nail hygiene and comfort.",
        },
      },
      {
        id: "foot_intervention_diabetic",
        label: "Observe feet regularly and report changes",
        description: "Caregivers should watch for skin, pain, and circulation concerns.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyDiabeticFootCare: true,
          diabeticFootCareAssistanceRequired: "Caregivers should observe the feet regularly, support protective care routines, and report redness, wounds, swelling, pain, or circulation-related concerns promptly.",
        },
      },
      {
        id: "foot_intervention_nail",
        label: "Support nail hygiene and escalate concerns",
        description: "Use when caregiver need to monitor comfort or abnormal nail changes.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyNailCare: true,
          nailCareAssistanceRequired: "Caregivers should support nail hygiene within their role, note discomfort or abnormal nail changes, and coordinate follow-up when additional foot or nail care is needed.",
        },
      },
    ],
  },
  levelQuestion(
    "skin_care",
    "Skin Care",
    "What best describes the resident's skin care level?",
    "typeOfSkinCare",
    "skinCareDetails",
    "skinCareAssistanceRequired",
    "skin care, skin monitoring, and protective routines",
    "skin care support and protective monitoring",
  ),
  {
    id: "skin_issues",
    title: "Skin Problems and Pressure Injury Risk",
    prompt: "What skin problems, pressure injuries, or treatment needs should be documented?",
    helperText: "Choose the skin-related details that apply and the caregiver steps that should happen consistently.",
    editableFieldKeys: [
      "skinProblemsDetails",
      "skinProblemsAssistanceRequired",
      "pressureInjuriesDetails",
      "pressureInjuriesAssistanceRequired",
    ],
    options: [
      {
        id: "skin_problem_present",
        label: "Has ongoing skin problems or fragile skin",
        description: "Rashes, tears, redness, dryness, or healing concerns affect care.",
        groupLabel: "Care details",
        updates: {
          anySkinProblems: true,
          skinProblemsDetails: "Resident has skin concerns such as fragile skin, dryness, redness, rashes, skin tears, wounds, or healing issues that require regular observation and care.",
        },
      },
      {
        id: "skin_pressure_risk",
        label: "Pressure injury risk or active pressure areas matter",
        description: "Positioning and pressure relief should be part of the plan.",
        groupLabel: "Care details",
        updates: {
          anyPressureInjuries: true,
          pressureInjuriesDetails: "Resident has pressure-injury risk or pressure-related skin concerns that require repositioning, pressure relief, and routine observation.",
        },
      },
      {
        id: "skin_intervention_monitor",
        label: "Check skin routinely and report changes",
        description: "Caregivers should watch for breakdown or worsening symptoms.",
        groupLabel: "Caregiver interventions",
        updates: {
          anySkinProblems: true,
          skinProblemsAssistanceRequired: "Caregivers should observe the skin routinely, protect vulnerable areas, provide hygiene and moisturizing support as directed, and report new redness, wounds, drainage, or breakdown promptly.",
        },
      },
      {
        id: "skin_intervention_pressure",
        label: "Use repositioning and pressure-relief steps",
        description: "Skin protection should stay consistent across caregivers.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyPressureInjuries: true,
          pressureInjuriesAssistanceRequired: "Caregivers should follow the pressure-relief plan, assist with repositioning, use supportive surfaces or devices as directed, and document or report changes in skin condition.",
        },
      },
    ],
  },
];

export const buildActivitiesOfDailyLivingGeniePreview = (
  currentValues: Record<string, any>,
  selectedOptions: Record<string, string[]>,
  questionDrafts: Record<string, Record<string, string>>,
) => buildCarePlanGeniePreview(
  ADL_GENIE_FIELD_DEFINITIONS,
  ADL_GENIE_QUESTIONS,
  currentValues,
  selectedOptions,
  questionDrafts,
);
